import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import React, { Fragment, Component } from 'react';
import { GetProductDataLibrary } from '../../../../shared/services';
import Modal from '../../components/Modal/Modal';
import TechnicalDocumentModal from '../../components/TechnicalDocument/TechnicalDocumentModal';
import { buildState, initialState } from './TechinicalDocumentState';

export default class TechnicalDocumentContainer extends Component {
  constructor(props) {
    super(props);
    this.state = initialState();

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillMount() {
    if (this.state.productDataLibraryUrl === null || this.state.productDataLibraryUrl === undefined) return;
    GetProductDataLibrary(this.state.productDataLibraryUrl).then(data => {
      this.setState(buildState({
        state: this.state,
        data,
      }));
      this.checkForTechnicalDocuments();
    }, () => {});
  }

  checkForTechnicalDocuments() {
    if (this.state.documentCount === 0 && this.state.technicalDocumentsNotFound) {
      const technicalReferenceElement = document.getElementsByClassName('TechnicalReference')[0];
      technicalReferenceElement.parentNode.removeChild(technicalReferenceElement);
    }
  }

  openModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }

  render() {
    return (
      <Fragment>
        {this.state.documentCount > 0 && this.state.documentCount <= 2 &&
        <div className="technical-row row download data-library-less">
          {this.state.documents.map(document => (
            <div className="col-xs-6" key={document.id}>
              <span className="icon icon-rs_137-zip" />
              <a href={document.href}>{document.title}</a>
            </div>
          ))}
        </div>
        }
        {this.state.documentCount > 2 &&
          <div className="technical-row row download data-library-more">
            <div className="col-xs-6">
              <span />
              <a tabIndex="-1" role="button" className="data-library-link" onClick={this.openModal}>
                <i className="icon icon-rs_56-text-open" aria-hidden="true" />
                {this.state.labels.exploreAllDocuments}
              </a>
            </div>
          </div>
        }
        <ReactCSSTransitionGroup transitionName="fade" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
          {this.state.showModal && <Modal
            key={1}
            className="data-library-dialog"
            header="My Modal"
            open={this.state.showModal}
            onClose={this.closeModal}
            showFooter={false}
            title={`${this.state.documents.length} ${this.state.labels.for} ${this.state.name}`}
          >
            <TechnicalDocumentModal
              closeModal={this.closeModal}
              documents={this.state.documents}
              dateFormat={this.state.dateFormat}
              labels={this.state.labels}
            />
          </Modal> }
        </ReactCSSTransitionGroup>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/containers/TechnicalDocument/TechnicalDocument.js